"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var captcha_component_1 = require("./lib/captcha.component");
var captcha_service_1 = require("./lib/captcha.service");
var ReCaptchaModule = (function () {
    function ReCaptchaModule() {
    }
    return ReCaptchaModule;
}());
ReCaptchaModule.decorators = [
    { type: core_1.NgModule, args: [{
                declarations: [captcha_component_1.ReCaptchaComponent],
                exports: [captcha_component_1.ReCaptchaComponent],
                providers: [captcha_service_1.RECAPTCHA_SERVICE_PROVIDER]
            },] },
];
/** @nocollapse */
ReCaptchaModule.ctorParameters = function () { return []; };
exports.ReCaptchaModule = ReCaptchaModule;
__export(require("./lib/captcha.component"));



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/angular2-recaptcha/angular2-recaptcha.js
// module id = ../../../../angular2-recaptcha/angular2-recaptcha.js
// module chunks = 3